import axios from 'axios'
import cache from './Cache'
import pageId from './PageId'
import Config from './Config'

var CONFIG_DATA = {
  client: 'h5',
  business_type: 1, // 业务类型: 1.移民,2.海房
  scene: '0000', // 场景值ID
  channel: '0000', // 渠道号
  urlClick: 'https://dc.hinabian.com/rpStat/appClick',
  urlPv: 'https://dc.hinabian.com/rpStat/appPV'
}

// 创建新的实例
function proxy (url) {
  if (process.env.NODE_ENV == 'development') {
    return url.replace('https://data.hinabian.com', '/data.hinabian.com')
  } else {
    return url
  }
}
var axiosReport = null

function request (url, data) {
  if (!axiosReport) {
    // 创建新的实例
    axiosReport = axios.create()
    axiosReport.defaults.withCredentials = true
    axiosReport.interceptors.request.use(
      config => {
        config.url = proxy(config.url)
        return config
      }
    )
  }
  //console.log('request=======>', url)
  axiosReport.post(url, data).then(() => {

  }).catch(() => {

  })
}

var Report = {
  /**
   * 初始化项目版本号和名称，
   * 在main.js里面调用
   * @param isSinglePages 是否是单页面应用
   */
  init: function (isSinglePages) {
    this.setCid(getUrlQuery('cid'))

    if (!isSinglePages) {
      // 统计pv
      this.pv(getUrlQuery('id'))

      // 第三方统计
      _hmt.push(['_trackPageview', getPagePath()])// 百度统计：必须是以"/"（斜杠）开头的相对路径
      ga('send', 'pageview', location.href)
    }
  },

  /**
   * 单页面应用在 router.afterEach 钩子函数中调用
   * @param to
   * @param from
   * @param base 路由base参数
   */
  routerAfterEach: function (base, to, from) {
    if (arguments.length != 3) {
      throw new Error('参数个数错误')
    }

    if (base == '' || base == '/') {
      base = '/'
    } else {
      base = base.substring(0, base.length - 1)
    }

    //console.log('to', to)

    let url_phb = location.protocol + '//' + location.host + base
    let url = url_phb + to.fullPath
    let referrer = url_phb + from.fullPath

    // 统计pv
    let id=''
    if (to.query && to.query.id && to.query.id != '') {
      id = to.query.id
    }
    cache.setSession('reportCacheData',{detail_id:id, path:to.path, mark:url})
    //this.pv(id, to.path, url)
    // 第三方统计
    _hmt.push(['_trackPageview', base + to.fullPath])// 百度统计：必须是以"/"（斜杠）开头的相对路径
    ga('send', 'pageview', url)
  },
  pv: function (detail_id, path, mark) {
    let pagePath = ''
    if (!path) {
      pagePath = getPagePath()
    } 
    //console.log('pagePath', pagePath)

    request(CONFIG_DATA.urlPv, {
      page_id: pageId.getId(pagePath),
      detail_id: detail_id || '',
      rp_time: new Date().getTime() / 1000,
      mark: mark || window.location.href,
      client: CONFIG_DATA.client,
      ver: Config.version,
      business_type: CONFIG_DATA.business_type,
      feature: getFeature(),
      attr: { fsid: getFsid() }
    })

    this.startPost()
  },
  selfPv:function(obj){
    let cacheParams=cache.getSession('reportCacheData')
    request(CONFIG_DATA.urlPv, {
      page_id: obj.page_id,
      detail_id: cacheParams.detail_id || '',
      rp_time: new Date().getTime() / 1000,
      mark: cacheParams.mark || window.location.href,
      client: CONFIG_DATA.client,
      ver: Config.version,
      business_type: CONFIG_DATA.business_type,
      feature: getFeature(),
      attr: { fsid: getFsid() }
    })
  },
  click: function (params, callback) {
    checkParams(params)
    request(CONFIG_DATA.urlClick, getClickData(params), callback)
  },
  clickDelay: function (params) {
    checkParams(params)

    let click_delay_data = cache.get('clickDelay', [])
    click_delay_data.push(getClickData(params))
    cache.set('clickDelay', click_delay_data)
  },
  startPost: function () {
    let click_delay_data = cache.get('clickDelay', [])
    if (click_delay_data.length > 0) {
      setTimeout(function () {
        if (click_delay_data.length > 0) {
          let data = click_delay_data.shift()
          cache.set('clickDelay', click_delay_data)
          request(CONFIG_DATA.urlClick, data)
        }
      }, 1000)
    }
  }

}

Report.setCid = function (cid) {
  cache.setSession('hnb_cid', cid)
}

Report.getCid = function () {
  var cid=cache.getSession('hnb_cid', '0000')
  return cid?cid:'0000'
}

function getFsid () {
  if (!cache.get('fsid')) {
    cache.set('fsid', getRandom())
  }

  return cache.get('fsid', '')
}

function getRandom (a) {
  for (var b = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], c = 10; c > 1; c--) {
    var d = Math.floor(10 * Math.random()), e = b[d]
    b[d] = b[c - 1]
    b[c - 1] = e
  }
  for (c = d = 0; c < 5; c++) d = 10 * d + b[c]
  return (a || '') + (d + '' + +new Date())
}

// 获取请求url参数
function getUrlQuery (name) {
  let href = window.location.href

  if (href.indexOf('?') == -1) {
    return null
  }

  let search = decodeURI(href.split('?')[1])

  var vars = search.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == name) { return pair[1] }
  }
  return null
}

function checkParams (params) {
  if (!params) throw new Error('params 不能为空！')
  //if (!params.click_id) throw new Error('params.click_id 不能为空！')
  // if (!params.mark) throw new Error('params.mark 不能为空！')
}

function getPagePath () {
  let url = document.location.toString()
  let arrUrl = url.split('//')

  let start = arrUrl[1].indexOf('/')
  let relUrl = arrUrl[1].substring(start)// stop省略，截取从start开始到结尾的所有字符

  if (relUrl.indexOf('?') != -1) {
    relUrl = relUrl.split('?')[0]
  }
  return relUrl
}

function getClickData (params) {
  let attr = params.attr || {}
  attr.fsid = getFsid()

  return {
    click_id: params.click_id,
    page_id: params.page_id || pageId.getId(getPagePath()),
    detail_id: params.detail_id ? params.detail_id : '',
    rp_time: new Date().getTime() / 1000,
    mark: params.mark,
    client: CONFIG_DATA.client,
    ver: Config.version,
    business_type: CONFIG_DATA.business_type,
    feature: getFeature(),
    referrer: document ? document.referrer : '',
    attr: attr
  }
}

function getFeature () {
  return {
    cid: Report.getCid()
  }
}

function getPlatform () {
  var userAgent = navigator.userAgent
  var device = '' // 当前设备信息
  if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1) { // 安卓手机
    device = 'android'
  } else if ((userAgent.match(/iPhone/i) != null) || (userAgent.match(/iPad/i) != null)) { // 苹果手机
    device = 'ios'
  } else if (userAgent.indexOf('Windows Phone') > -1) { // winphone手机
    device = 'indowsphone'
  }
  return device
}

export default Report
